import { ClubDescriptionWidget } from "components/PoisBountyWidgetV3/lib/common/InfoButton/styles";
import styled from "styled-components";

export const Container = styled.section`
	position: relative;
	margin-bottom: 3em;
	font-size: clamp(7px, 2.667vw, 17px);

	@media (min-width: 720px) {
		font-size: clamp(7px, 0.8027vw, 14px);
	}
	@media (min-width: 1536px) {
		font-size: clamp(10px, 0.5827vw, 20px);
	}
`;

export const Background = styled.div<{ bgImg: string }>`
	position: absolute;
	width: 100%;
	background-image: url(${(props) => props.bgImg});
	background-position: center bottom;
	background-repeat: no-repeat;
	background-size: cover;
	display: block;
	z-index: -1;
	height: 38.4em;

	@media (min-width: 720px) {
		height: 39.4em;
	}
	@media (min-width: 1536px) {
		height: 42.4em;
	}
`;

export const Title = styled.img<{ isClub: boolean }>`
	position: absolute;
	top: ${(props) => (props.isClub ? "4.4em" : "5.4em")};
	transform: ${(props) => (props.isClub ? "translateX(-50%)" : "none")};
	left: ${(props) => (props.isClub ? "50%" : "0em")};
	width: ${(props) => (props.isClub ? "14.2em" : "22.5em")};

	@media (min-width: 720px) {
		top: ${(props) => (props.isClub ? "8.4em" : "7.4em")};
		left: ${(props) => (props.isClub ? "50%" : "18.4em")};
		width: ${(props) => (props.isClub ? "26.6em" : "37.1em")};
	}
`;

export const Description = styled.p`
	position: absolute;
	top: 7em;
	width: 100%;

	color: #fff;
	text-align: center;
	paint-order: stroke fill;
	filter: drop-shadow(0 0.07em 0 #000);
	-webkit-text-stroke-width: 0.15em;
	-webkit-text-stroke-color: #000;
	font-family: "Baloo";
	font-size: 1.8em;
	font-style: normal;
	font-weight: 400;
	line-height: 1.333em;
	margin: 0;

	span {
		color: #fbbd05;
	}

	@media (min-width: 720px) {
		font-size: 3.3em;
		line-height: 1.182em;
	}
`;

export const ClubDescription = styled(ClubDescriptionWidget)`
	position: absolute;
	top: 18.6em;
	left: 50%;
	transform: translateX(-50%);
`;

export const PoisBountyWrapper = styled.div<{ isClub: boolean }>`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 18em;

	@media (min-width: 470px) {
		margin-top: ${(props) => (props.isClub ? "19em" : "18em")};
	}

	@media (min-width: 720px) {
		margin-top: 26em;
	}

	@media (min-width: 945px) and (max-width: 1132px) {
		margin-top: 23em;
	}
`;

export const Box1 = styled.div`
	width: 34.3em;
	box-shadow: 0px 15px 15px rgba(0, 0, 0, 0.1);
	border-radius: 18px;
	[class*="pois-bounty-widget"] {
		max-width: none;
	}

	@media (min-width: 720px) {
		width: 95.8em;
	}
`;
